import { render, staticRenderFns } from "./limitareaset_arealist.vue?vue&type=template&id=15374d87"
import script from "./limitareaset_arealist.vue?vue&type=script&lang=js"
export * from "./limitareaset_arealist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports